/**
 * @generated SignedSource<<cd0bfae9e92b13271ef5404d0bc431cc>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type BranchSettingsDialog_pipeline$fragmentType: FragmentType;
export type BranchSettingsDialog_pipeline$data = {|
  +defaultBranch: ?string,
  +id: string,
  +name: string,
  +organization: {|
    +name: string,
  |},
  +$fragmentType: BranchSettingsDialog_pipeline$fragmentType,
|};
export type BranchSettingsDialog_pipeline$key = {
  +$data?: BranchSettingsDialog_pipeline$data,
  +$fragmentSpreads: BranchSettingsDialog_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BranchSettingsDialog_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultBranch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "7741e68d4cc320ed8ea6af538a5777be";

module.exports = ((node/*: any*/)/*: Fragment<
  BranchSettingsDialog_pipeline$fragmentType,
  BranchSettingsDialog_pipeline$data,
>*/);
